import en from './english';
import tr from './turkish';

export default {
  'en-US': en,
  'tr-TR': tr,
  'tr': tr,
  default: 'tr-TR',
};
